import { useState, useCallback, useEffect, useRef } from "react";
import './Header.css';

const MENU_TRANSITION_MS = 400;
const MEGAMENU_LEFT_OFFSET = 20;

const menuOptions = [
    {
        id: 'modelos',
        title: 'Modelos',
        columns: [
            {
                header: 'Encuentra y compara modelos',
                links: [
                    { href: 'https://www.audi.com.mx/es/models/', text: 'Model Finder' },
                    { href: 'https://www.audi.com.mx/es/models/comparar-modelos/', text: 'Comparar modelos' },
                ]
            },
            {
                header: 'Disponibilidad inmediata',
                links: [
                    { href: 'https://www.audi.com.mx/es/new-car-search/', text: 'Autos nuevos disponibles' },
                    { href: 'https://www.audi.com.mx/es/certified-plus/', text: 'Autos seminuevos disponibles' },
                ]
            }
        ]
    },
    {
        id: 'experiencia',
        title: 'Experiencia',
        columns: [
            {
                header: 'Experiencia',
                links: [
                    { href: 'https://www.audi.com.mx/es/experiencia/promocAudi/', text: 'Promociones' },
                    { href: 'https://www.audi.com.mx/es/servicios-al-cliente/audi_financial_services/', text: 'Audi Financial Services' },
                    { href: 'https://www.appsaudi.com.mx/Lifestyle/collection/home', text: 'Audi Collection', external: true },
                    { href: 'https://www.appsaudi.com.mx/Lifestyle/accesorios/home', text: 'Audi Accesorios', external: true },
                    { href: 'https://www.audi.com.mx/es/experiencia/audi-exclusive/', text: 'Audi exclusive' },
                    { href: 'https://www.audi.com.mx/es/experiencia/temporadas/Power_interviews/', text: 'Próximo Destino' },
                    { href: 'https://www.audi.com.mx/es/experiencia/go-green/', text: 'Audi Go Green' },
                    { href: 'https://www.audi.com/en.html', text: 'Audi internacional', external: true },
                    { href: 'https://audinewsletter.com.mx/?news_year=2019&news_month=09', text: 'e-Newsletter', external: true },
                ]
            },
            {
                header: 'Audi certified plus',
                links: [
                    { href: 'https://www.audi.com.mx/es/certified-plus/certified/', text: 'Audi Certified :plus' },
                    { href: 'https://www.audi.com.mx/es/certified-plus/certified/concesionarios_audi_certified_plus/', text: 'Concesionarios Audi Certified :plus' },
                ]
            },
            {
                header: 'Historias de progreso',
                links: [
                    { href: 'https://www.audi.com.mx/es/historias-de-progreso/', text: 'Descripción general' },
                    { href: 'https://www.audi.com.mx/es/historias-de-progreso/sustentabilidad/', text: 'Sustentabilidad' },
                    { href: 'https://www.audi.com.mx/es/historias-de-progreso/motorsport/', text: 'Motorsport' },
                    { href: 'https://www.audi.com.mx/es/historias-de-progreso/diseno/', text: 'Diseño' },
                    { href: 'https://www.audi.com.mx/es/historias-de-progreso/tecnologia/', text: 'Tecnología' },
                    { href: 'https://www.audi.com.mx/es/historias-de-progreso/lifestyle/', text: 'Lifestyle' },
                ]
            },
            {
                header: 'Contacto',
                links: [
                    { href: 'https://www.appsaudi.com.mx/audi-forms/salesforce/audi-nuevo?utm_source=audi&utm_medium=referral&utm_campaign=site_general_form', text: 'Quiero comprar un Audi nuevo' },
                    { href: 'https://www.audi.com.mx/es/models/forms/sugerencia/', text: 'Sugerencias y comentarios' },
                    { href: 'https://www.audi.com.mx/es/models/forms/informacion/', text: 'Solicitar información' },
                ]
            }
        ]
    },
    {
        id: 'myaudi',
        title: 'myAudi',
        columns: [
            {
                header: 'Servicios al cliente',
                links: [
                    { href: 'https://www.audi.com.mx/es/servicios-al-cliente/atencion_a_clientes/', text: 'Atención a clientes' },
                    { href: 'https://www.audi.com.mx/es/servicios-al-cliente/audi_financial_services/', text: 'Audi Financial Services' },
                    { href: 'https://www.audi.com.mx/es/servicios-al-cliente/postventa/', text: 'Postventa' },
                    { href: 'https://www.audi.com.mx/es/servicios-al-cliente/postventa/garantia-extendida/', text: 'Garantía extendida' },
                    { href: 'https://www.audi.com.mx/es/servicios-al-cliente/audi-contigo/', text: 'Audi contigo' },
                    { href: 'https://www.audi.com.mx/es/servicios-al-cliente/audi_connect/', text: 'Audi Connect' },
                    { href: 'https://www.audi.com.mx/es/servicios-al-cliente/audi_waiting/', text: 'Delivery situation' },
                ]
            },
            {
                header: 'Llamados',
                links: [
                    { href: 'https://www.audi.com.mx/es/servicios-al-cliente/postventa/recall-revision/', text: 'Llamado a revisión general' },
                    { href: 'https://www.audi.com.mx/es/servicios-al-cliente/postventa/recall-airbag/', text: 'Llamado a revisión de bolsas de aire' },
                ]
            },
            {
                header: 'Postventa',
                links: [
                    { href: 'https://www.audi.com.mx/es/models/forms/postventa/', text: 'Servicios postventa' },
                    { href: 'https://www.audi.com.mx/es/models/forms/rh/', text: 'Recursos humanos' },
                    { href: 'https://www.audi.com.mx/es/models/forms/quejas/', text: 'Quejas' },
                    { href: 'https://www.audi.com.mx/es/models/forms/otro/', text: 'Otros' },
                ]
            }
        ]
    }
];

const ChevronRight = (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
        <path d="M9 6L15 12L9 18" />
    </svg>
);

const ChevronLeft = (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
        <path d="M15 6L9 12L15 18" />
    </svg>
);

const MenuLink = ({ link, className }) => (
    <a
        className={className}
        href={link.href}
        target={link.external ? '_blank' : undefined}
        rel={link.external ? 'noreferrer' : undefined}
    >
        {link.text}
    </a>
);

const Header = () => {
    const [activeMenu, setActiveMenu] = useState(null);
    const [displayedOption, setDisplayedOption] = useState(null);
    const [menuVisible, setMenuVisible] = useState(false);
    const [overlayVisible, setOverlayVisible] = useState(false);
    const [navOffset, setNavOffset] = useState(0);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [activeMobileSubmenu, setActiveMobileSubmenu] = useState(null);
    const headerRef = useRef(null);
    const navBtnRefs = useRef([]);
    const closeTimerRef = useRef(null);

    const toggleMobileMenu = useCallback(() => {
        setIsMobileMenuOpen(prev => {
            const next = !prev;
            document.body.style.overflow = next ? 'hidden' : '';
            if (!next) setActiveMobileSubmenu(null);
            return next;
        });
    }, []);

    const closeMenu = useCallback(() => {
        clearTimeout(closeTimerRef.current);
        setActiveMenu(null);
        setMenuVisible(false);
        setOverlayVisible(false);
        closeTimerRef.current = setTimeout(() => setDisplayedOption(null), MENU_TRANSITION_MS);
    }, []);

    const handleNavClick = useCallback((menuId) => {
        clearTimeout(closeTimerRef.current);
        const option = menuOptions.find(opt => opt.id === menuId);
        if (activeMenu === menuId) {
            // Cerrar
            closeMenu();
        } else if (activeMenu !== null) {
            // Cambiar de opción: cerrar menu, mantener overlay, abrir con nuevo contenido
            setActiveMenu(menuId);
            setMenuVisible(false);
            closeTimerRef.current = setTimeout(() => {
                setDisplayedOption(option);
                setMenuVisible(true);
            }, MENU_TRANSITION_MS);
        } else {
            // Abrir desde cerrado
            setDisplayedOption(option);
            setActiveMenu(menuId);
            setMenuVisible(true);
            setOverlayVisible(true);
        }
    }, [activeMenu, closeMenu]);

    useEffect(() => {
        return () => {
            document.body.style.overflow = '';
            clearTimeout(closeTimerRef.current);
        };
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (headerRef.current && !headerRef.current.contains(e.target)) {
                closeMenu();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [closeMenu]);

    useEffect(() => {
        const updateOffset = () => {
            const firstBtn = navBtnRefs.current[0];
            if (firstBtn && headerRef.current) {
                const btnRect = firstBtn.getBoundingClientRect();
                const headerRect = headerRef.current.getBoundingClientRect();
                setNavOffset(btnRect.left - headerRect.left + MEGAMENU_LEFT_OFFSET);
            }
        };
        updateOffset();
        window.addEventListener('resize', updateOffset);
        return () => window.removeEventListener('resize', updateOffset);
    }, []);

    return (
        <header className="audi-header" ref={headerRef}>
            <div className="audi-header__bar">
                {/* Botón hamburguesa - solo mobile */}
                <button
                    className={`audi-header__hamburger ${isMobileMenuOpen ? 'is-open' : ''}`}
                    onClick={toggleMobileMenu}
                    aria-label={isMobileMenuOpen ? 'Cerrar menú' : 'Abrir menú'}
                    aria-expanded={isMobileMenuOpen}
                >
                    <div className="audi-header__hamburger-icon">
                        <span />
                        <span />
                        <span />
                    </div>
                    <span className="audi-header__hamburger-label">Menú</span>
                </button>

                <a className={`audi-header__logo ${isMobileMenuOpen ? 'is-hidden' : ''}`} href="https://www.audi.com.mx/es/" aria-label="Audi" title="Audi">
                    <svg xmlns="http://www.w3.org/2000/svg" width="69" height="24" viewBox="0 0 69 24" fill="none">
                        <path d="M57.0623 21.3142C54.9409 21.3142 52.9856 20.5922 51.422 19.3822C53.0087 17.3448 53.9585 14.7826 53.9585 12C53.9585 9.21768 53.0087 6.65544 51.422 4.61784C52.9856 3.408 54.9409 2.68584 57.0623 2.68584C62.1714 2.68584 66.3281 6.86424 66.3281 12C66.3281 17.136 62.1714 21.3142 57.0623 21.3142ZM36.3802 19.3822C37.9672 17.3448 38.917 14.7826 38.917 12C38.917 9.21768 37.9672 6.65544 36.3804 4.61784C37.9438 3.408 39.8997 2.68584 42.0208 2.68584C44.1421 2.68584 46.0975 3.408 47.6611 4.61784C46.0743 6.65544 45.1246 9.21768 45.1246 12C45.1246 14.7826 46.0743 17.3448 47.6611 19.3822C46.0975 20.5922 44.1421 21.3142 42.0208 21.3142C39.8997 21.3142 37.9438 20.5922 36.3802 19.3822ZM21.3387 19.3822C22.9257 17.3448 23.8754 14.7826 23.8754 12C23.8754 9.21768 22.9257 6.65544 21.3389 4.61784C22.9023 3.408 24.8581 2.68584 26.9792 2.68584C29.1003 2.68584 31.0562 3.408 32.6196 4.61784C31.0328 6.65544 30.083 9.21768 30.083 12C30.083 14.7826 31.0328 17.3448 32.6196 19.3822C31.0562 20.5922 29.1003 21.3142 26.9792 21.3142C24.8581 21.3142 22.9023 20.5922 21.3387 19.3822ZM2.6719 12C2.6719 6.86424 6.82861 2.68584 11.9377 2.68584C14.0588 2.68584 16.0147 3.408 17.578 4.61784C15.9913 6.65544 15.0415 9.21768 15.0415 12C15.0415 14.7826 15.9913 17.3448 17.578 19.3822C16.0147 20.5922 14.0588 21.3142 11.9377 21.3142C6.82861 21.3142 2.6719 17.136 2.6719 12ZM19.4585 17.4305C18.3619 15.9005 17.7134 14.0256 17.7134 12C17.7134 9.97464 18.3619 8.09952 19.4585 6.56952C20.5551 8.09952 21.2035 9.97464 21.2035 12C21.2035 14.0256 20.5551 15.9005 19.4585 17.4305ZM34.5 17.4305C33.4034 15.9005 32.7549 14.0256 32.7549 12C32.7549 9.97464 33.4034 8.09952 34.5 6.56952C35.5966 8.09952 36.2451 9.97464 36.2451 12C36.2451 14.0256 35.5966 15.9005 34.5 17.4305ZM49.5415 17.4305C48.4449 15.9005 47.7965 14.0256 47.7965 12C47.7965 9.97464 48.4449 8.09952 49.5415 6.56952C50.6381 8.09952 51.2866 9.97464 51.2866 12C51.2866 14.0256 50.6381 15.9005 49.5415 17.4305ZM57.0623 0C54.2135 0 51.5958 1.00968 49.5415 2.68968C47.4873 1.00968 44.8696 0 42.0208 0C39.1719 0 36.5542 1.00968 34.5 2.68968C32.4458 1.00968 29.8278 0 26.9792 0C24.1304 0 21.5127 1.00968 19.4585 2.68968C17.4042 1.00968 14.7863 0 11.9377 0C5.35526 0 0 5.3832 0 12C0 18.617 5.35526 24 11.9377 24C14.7863 24 17.4042 22.9906 19.4585 21.3103C21.5127 22.9906 24.1304 24 26.9792 24C29.8278 24 32.4458 22.9906 34.5 21.3103C36.5542 22.9906 39.1719 24 42.0208 24C44.8696 24 47.4873 22.9906 49.5415 21.3103C51.5958 22.9906 54.2135 24 57.0623 24C63.6447 24 69 18.617 69 12C69 5.3832 63.6447 0 57.0623 0Z" fill="white" />
                    </svg>
                </a>

                {/* Navegación principal - desktop */}
                <nav className="audi-header__nav" aria-label="Navegación principal">
                    {menuOptions.map((option, idx) => (
                        <button
                            key={option.id}
                            ref={el => navBtnRefs.current[idx] = el}
                            className={`audi-header__nav-item ${activeMenu === option.id ? 'active' : ''}`}
                            onClick={() => handleNavClick(option.id)}
                            aria-expanded={activeMenu === option.id}
                        >
                            {option.title}
                        </button>
                    ))}
                </nav>
            </div>

            <div
                className={`audi-header__overlay ${overlayVisible ? 'is-open' : ''}`}
                onClick={closeMenu}
                aria-hidden="true"
            />

            {/* Menu mobile */}
            <div className={`audi-mobile-menu ${isMobileMenuOpen ? 'is-open' : ''}`} aria-hidden={isMobileMenuOpen ? undefined : 'true'}>
                {/* Panel principal - lista de opciones */}
                <div className={`audi-mobile-menu__main ${activeMobileSubmenu ? 'is-hidden' : ''}`}>
                    {menuOptions.map(option => (
                        <button
                            key={option.id}
                            className="audi-mobile-menu__trigger"
                            onClick={() => setActiveMobileSubmenu(option.id)}
                            aria-expanded={activeMobileSubmenu === option.id}
                        >
                            {option.title}
                            {ChevronRight}
                        </button>
                    ))}
                </div>

                {/* Paneles de submenu (uno por opción) */}
                {menuOptions.map(option => (
                    <div
                        key={option.id}
                        className={`audi-mobile-menu__submenu-panel ${activeMobileSubmenu === option.id ? 'is-open' : ''}`}
                    >
                        <button
                            className="audi-mobile-menu__back"
                            onClick={() => setActiveMobileSubmenu(null)}
                        >
                            {ChevronLeft}
                            {option.title}
                        </button>

                        <div className="audi-mobile-menu__submenu-content">
                            {option.columns.map((col) => (
                                <div key={col.header} className="audi-mobile-menu__col">
                                    <p className="audi-mobile-menu__col-header">{col.header}</p>
                                    <ul>
                                        {col.links.map((link) => (
                                            <li key={link.href}>
                                                <MenuLink link={link} />
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>

            <div
                className={`audi-megamenu ${menuVisible ? 'is-open' : ''}`}
                role="region"
                aria-label="Mega menú"
            >
                {displayedOption && (
                    <div
                        className="audi-megamenu__inner"
                        style={{
                            paddingLeft: navOffset,
                            '--cols': displayedOption.columns.length
                        }}
                    >
                        {displayedOption.columns.map((col) => (
                            <div key={col.header} className="audi-megamenu__column">
                                <p className="audi-megamenu__column-header">{col.header}</p>
                                <ul className="audi-megamenu__links">
                                    {col.links.map((link) => (
                                        <li key={link.href}>
                                            <MenuLink link={link} className="audi-megamenu__link" />
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header;
